// Bootstrap declarations
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// Bringing up the additional content to add to the app modal
import AboutModalCommonNote from "../../components/shared/AboutModalCommonNote"

import FooterWalletConnector from "../../components/shared/FooterWalletConnect"

// Context modules
import { useSharedNavigationFunctions } from "../../shared/NavigationFunctions";

const Footer = (props) => {

    // Retrieve items from context --------------------------------------------------
    // Navigation functions
    const { 
        handleModalClose,
        modalShow,
    } = useSharedNavigationFunctions();
    // Retrieve items from context --------------------------------------------------



    return (

    <>
        <footer className="footer container-fluid">
            <FooterWalletConnector nftEntityName="KillaBear" doConnectWallet={false} />
        </footer>
    </>

    );

}

export default Footer;